// extracted by mini-css-extract-plugin
export default {"container":"insurance_container__GA-91"};